export const Validator = {

  none: () => true,

  default: (v: any, o: any, b: any) => {
    if (v?.length > 190) {
      b(useT('validation.max',{max: 190}));
    }

    return true;
  },

  callsign: (v: any, _o: any, b: any) => {
    const normalized = String(v).replace(/-/g, '');

    if (normalized.length < 3) {
      b(useT('validation.min',{max: 3}));
    }

    if (!/^[A-Z0-9]{1,10}$/.test(normalized)) {
      for (const char of normalized) {
        if (!/[A-Z0-9]/.test(char)) {
          b(`Letter "${char}" invalid`);
        }
      }

      if (normalized.length > 10) {
        b(useT('validation.max',{max: 10}));
      }
    }

    // if contains any lowercase
    if (/[a-z]/.test(normalized)) {
      b('Callsign must not contain lowercase letters');
    }

    // if contains any Ü,ü or accents
    if (/[üÜ]/.test(normalized)) {
      b('Callsign must not contain accents');
    }
  },

  icao: (v: any, _o: any) => {
    if(v?.length !== 4) return 'Callsign must be 4 characters long'
    return ws.send('aerodrome.icao',{icao:v}).then((aerodrome) => {
      return aerodrome?.name
    })
  },

  firstname: (v: any, _o: any, bagging: any) => {
    if(v?.length < 2) bagging(useT('validation.min',{min: 2}))
    if(v?.length >= 190) bagging(useT('validation.max',{max: 190}))
  },

  username: (v: any, _o: any, bagging: any) => {
    if(v?.length < 3) bagging(useT('validation.min',{min: 3}))
    if(v?.length > 190) bagging(useT('validation.max',{max: 190}))

    return ws.send('app.username', {username:v})
  },

  password: (v: any, o: any, bagging: any) => {
    if(v?.length < 8) bagging(useT('validation.min',{min: 8}))
    if(v?.length >= 190) bagging(useT('validation.max',{max: 190}))
    if(/(.)\1\1/.test(v)) bagging('Password must not contain 3 same letters in a row')
  },

  password_confirmed: (v: any, _o: any, bagging: any) => {
    Validator.password(v, _o, bagging)
    // if(v !== dataNewPassword) return 'Passwords do not match'
    return true;
  },

  email: (v: any, _o: any, bagging: any) => {
    if (!v) return;
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) bagging(useT('validation.invalid',{label: useT('email')}))
    if(v?.length > 190) bagging(useT('validation.max',{max: 190}))
  },

  phone: (v: any, _o: any, bagging: any) => {
    if (!v) return;
    if(!/^\+?[0-9\s\-()]{7,20}$/.test(v)) bagging(useT('validation.invalid',{label: useT('Phone')}))
    if(v?.length > 20) bagging(useT('validation.max',{max: 20}))
  },

  zip: (v: any, _o: any, bagging: any) => {
    if (v?.length < 2) return bagging(useT('validation.min',{min: 2}))
    if(v?.length > 16) bagging(useT('validation.max',{max: 16}))
  },

  website: (v: any, _o: any, bagging: any) => {
    if (!v) return;
    if(v?.length > 190) bagging(useT('validation.max',{max: 190}))

    if (
      !v.startsWith('http://'.substring(0,v?.length))
      && !v.startsWith('https://'.substring(0,v?.length))
    ) {
      return bagging(useT('validation.invalid',{label: useT('Website')}))
    }

    // Check for TLD
    const urlParts = v.split('.')
    if (urlParts.length < 2) {
      return bagging(useT('validation.invalid',{label: useT('Website')}))
    }

    const tld = urlParts[urlParts.length - 1]

    if (tld.length < 2 || tld.length > 6) {
      return bagging(useT('validation.invalid',{label: useT('Website')}))
    }
  }
}
